
        require('./index.scss');
        'use strict';

require('module/home-index/header/header-nav');

require('assets/util/json2.js');

require('module/home-detail/friend-link');

require('module/home-list/hot');

require('module/home-list/list');

require('module/home-list/tab');

require('module/home-index/right-toolbar');

require('module/home-index/decoration-cal');

require('module/home-index/design-free');

require('@front-end/common-module-vm/feedback-dialog');

require('module/home-detail/breadcrumbs');

require('module/home-list/header-banner');

require('module/home-list/bottom-ad');

require('module/home-list/cross-ad');

require('module/home-list/sidebar-ad');

$(document).ready(function () {
    $('.btn-open-wx').remove();
    $('.btn-open-platform:first').remove();

    var nav = $('.nav-header-wrap').find('li');
    var cate = $('body').attr('data-cate');
    var banner = $('.module-header-banner');
    var side = $('.side');
    for (var i = 0; i < nav.length; i++) {
        if (cate == nav[i].innerText) nav.eq(i).addClass('cur');else nav.eq(i).removeClass('cur');
    }
    if (banner.length == 0) {
        side.css('top', '8px');
    } else {
        side.css('top', '0');
    }
});;
    


// WEBPACK FOOTER //
// ./src/page/home-list/index.js